import { useId as e } from "@radix-ui/react-id";
import * as t from "@radix-ui/react-roving-focus";
import { createRovingFocusGroupScope as o } from "@radix-ui/react-roving-focus";
import { Primitive as a } from "@radix-ui/react-primitive";
import { useControllableState as r } from "@radix-ui/react-use-controllable-state";
import { createContextScope as n } from "@radix-ui/react-context";
import { composeEventHandlers as i } from "@radix-ui/primitive";
import * as s from "react";
import c from "@babel/runtime/helpers/esm/extends";
const [d, l] = n("Tabs", [o]);
export { l as createTabsScope };
const u = o(),
  [b, p] = d("Tabs");
export const Tabs = /*#__PURE__*/s.forwardRef((t, o) => {
  const {
      __scopeTabs: n,
      value: i,
      onValueChange: d,
      defaultValue: l,
      orientation: u = "horizontal",
      dir: p = "ltr",
      activationMode: m = "automatic",
      ...f
    } = t,
    [v, T] = r({
      prop: i,
      onChange: d,
      defaultProp: l
    }); /*#__PURE__*/
  return s.createElement(b, {
    scope: n,
    baseId: e(),
    value: v,
    onValueChange: T,
    orientation: u,
    dir: p,
    activationMode: m
  }, /*#__PURE__*/s.createElement(a.div, c({
    "data-orientation": u
  }, f, {
    ref: o
  })));
}); /*#__PURE__*/
export const TabsList = /*#__PURE__*/s.forwardRef((e, o) => {
  const {
      __scopeTabs: r,
      loop: n = !0,
      ...i
    } = e,
    d = p("TabsList", r),
    l = u(r); /*#__PURE__*/
  return s.createElement(t.Root, c({
    asChild: !0
  }, l, {
    orientation: d.orientation,
    dir: d.dir,
    loop: n
  }), /*#__PURE__*/s.createElement(a.div, c({
    role: "tablist",
    "aria-orientation": d.orientation,
    dir: d.dir
  }, i, {
    ref: o
  })));
}); /*#__PURE__*/
export const TabsTrigger = /*#__PURE__*/s.forwardRef((e, o) => {
  const {
      __scopeTabs: r,
      value: n,
      disabled: d = !1,
      ...l
    } = e,
    b = p("TabsTrigger", r),
    v = u(r),
    T = m(b.baseId, n),
    x = f(b.baseId, n),
    g = n === b.value; /*#__PURE__*/
  return s.createElement(t.Item, c({
    asChild: !0
  }, v, {
    focusable: !d,
    active: g
  }), /*#__PURE__*/s.createElement(a.button, c({
    type: "button",
    role: "tab",
    "aria-selected": g,
    "aria-controls": x,
    "data-state": g ? "active" : "inactive",
    "data-disabled": d ? "" : void 0,
    disabled: d,
    id: T
  }, l, {
    ref: o,
    onMouseDown: i(e.onMouseDown, e => {
      d || 0 !== e.button || !1 !== e.ctrlKey ? e.preventDefault() : b.onValueChange(n);
    }),
    onKeyDown: i(e.onKeyDown, e => {
      [" ", "Enter"].includes(e.key) && b.onValueChange(n);
    }),
    onFocus: i(e.onFocus, () => {
      const e = "manual" !== b.activationMode;
      g || d || !e || b.onValueChange(n);
    })
  })));
}); /*#__PURE__*/
export const TabsContent = /*#__PURE__*/s.forwardRef((e, t) => {
  const {
      __scopeTabs: o,
      value: r,
      children: n,
      ...i
    } = e,
    d = p("TabsContent", o),
    l = m(d.baseId, r),
    u = f(d.baseId, r),
    b = r === d.value; /*#__PURE__*/
  return s.createElement(a.div, c({
    "data-state": b ? "active" : "inactive",
    "data-orientation": d.orientation,
    role: "tabpanel",
    "aria-labelledby": l,
    hidden: !b,
    id: u,
    tabIndex: 0
  }, i, {
    ref: t
  }), b && n);
}); /*#__PURE__*/
function m(e, t) {
  return "".concat(e, "-trigger-").concat(t);
}
function f(e, t) {
  return "".concat(e, "-content-").concat(t);
}
export const Root = Tabs;
export const List = TabsList;
export const Trigger = TabsTrigger;
export const Content = TabsContent;